import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard } from '@shared/router';
import { Route } from 'react-router-dom';

import { helpContactSupportPath } from './urls';

const ContactSupportView = lazyWithReload(() =>
  import('./pages/ContactSupport').then((m) => ({ default: m.ContactSupportPage }))
);

export const HelpRoutes = (
  <>
    <Route
      path={helpContactSupportPath}
      element={
        <PermissionGuard>
          <ContactSupportView />
        </PermissionGuard>
      }
    />
  </>
);
